/* PetalHush homepage behaviour: scroll reveal and the try-it studio demo.
   Loaded with `defer` from snippets/ph-assets.liquid (once per ph-* section; guarded below).
   Re-initialises on theme-editor section reloads (shopify:section:load). */
(function () {
  if (window.PetalHush) return;
  var PH = (window.PetalHush = {});
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ph-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('.ph-rv:not(.ph-in)').forEach(function (el) {
      if (io && document.documentElement.classList.contains('ph-js')) io.observe(el);
      else el.classList.add('ph-in');
    });
  }

  /* ---------- try-it studio (demo only: the photo never leaves the browser) ---------- */
  function initStudio(studio) {
    if (studio.dataset.phReady) return;
    studio.dataset.phReady = '1';
    var msg = studio.querySelector('[data-ph-msg]');
    var face = studio.querySelector('[data-ph-face]');
    var engr = studio.querySelector('[data-ph-engrave]');
    var nameIn = studio.querySelector('[data-ph-name]');
    var file = studio.querySelector('[data-ph-file]');
    var t = studio.dataset;
    function say(s) { if (msg) msg.textContent = s || ''; }

    studio.querySelectorAll('[data-ph-metal]').forEach(function (b) {
      b.addEventListener('click', function () {
        studio.querySelectorAll('[data-ph-metal]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        studio.dataset.metal = b.dataset.phMetal;
      });
    });

    if (nameIn && engr) {
      nameIn.addEventListener('input', function () {
        engr.textContent = nameIn.value || ' ';
        say(nameIn.value.length >= nameIn.maxLength ? t.msgLimit : '');
      });
    }

    if (file && face) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (!f) return;
        var okType = /^image\/(jpeg|png|heic|heif|webp)$/.test(f.type) || /\.(jpe?g|png|heic|heif|webp)$/i.test(f.name);
        if (!okType) { say(t.msgType); return; }
        say(t.msgAdding);
        face.onload = function () { say(t.msgSuccess); };
        face.onerror = function () { say(t.msgError); };
        face.removeAttribute('srcset');
        face.src = URL.createObjectURL(f);
      });
    }
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    root.querySelectorAll('[data-ph-studio]').forEach(initStudio);
  }

  PH.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
